import { OnInit, EventEmitter } from '@angular/core';
import { TextboxQuestion } from '../../shared/models/textbox-question';
var QuestionTextboxComponent = /** @class */ (function () {
    function QuestionTextboxComponent() {
        this.answered = new EventEmitter();
    }
    QuestionTextboxComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(QuestionTextboxComponent.prototype, "Question", {
        get: function () {
            return this.question;
        },
        enumerable: true,
        configurable: true
    });
    QuestionTextboxComponent.prototype.handleChange = function (text) {
        this.question.answer = text;
        this.answered.emit(this.question);
    };
    return QuestionTextboxComponent;
}());
export { QuestionTextboxComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question-textbox/question-textbox.component.ts.pre-build-optimizer.js